import type { FlightMeta } from "../api/types";
import type { LocalityFlight } from "./LocalityMap";

/** A `[lat, lon]` pair Leaflet can take. Anything else — a string, a NaN, a
 *  three-element point — throws inside Leaflet and blanks the page, so the
 *  flight carrying it is dropped instead. */
function isLatLng(p: unknown): p is [number, number] {
  return Array.isArray(p) && p.length === 2
    && Number.isFinite(p[0]) && Number.isFinite(p[1]);
}

/** The flights a section's LocalityMap draws, numbered by card position.
 *  A flight without the locality fields keeps its number (so the badges on
 *  the cards still count 1, 2, 3 …) but is not drawn. */
export function localityFlights(
  ordered: FlightMeta[],
  hrefFor: (f: FlightMeta) => string,
): LocalityFlight[] {
  const out: LocalityFlight[] = [];
  ordered.forEach((f, i) => {
    const preview = f.track?.preview;
    const bounds = f.track?.bounds;
    if (preview === undefined || bounds === undefined || preview.length < 2) return;
    if (!isLatLng(bounds[0]) || !isLatLng(bounds[1])) return;
    if (!preview.every(isLatLng)) return;
    out.push({
      key: `${f.team}/${f.flightId}`,
      index: i + 1,
      name: f.name,
      preview,
      bounds,
      href: hrefFor(f),
    });
  });
  return out;
}
